import React, { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';

import '../../css/components/batches/NotificationBox.css';

const NotificationBox = ({ type, message, color = 'base' }) => {
    const isMobile = useMediaQuery({
        maxDeviceWidth: 600,
    });
    return (
        <div
            id="c-notification-box"
            data-testid="c-notification-box"
            className={`c-notification  c-notification--${type} u-p-none`}
        >
            <div className="c-notification__outer-wrap u-ph-xsmall u-pv-small u-ml-xsmall u-bg-alternative">
                <div className="c-notification__inner-wrap u-ph-small">
                    <i
                        className={`c-notification__status-icon u-text-${color} u-flex u-text-fs-1 u-pt-small@s`}
                        style={isMobile ? { alignSelf: 'flex-start' } : {}}
                    />
                    <div className="c-notification__content u-flex">
                        <p
                            className={`c-notification__text u-text-${color} u-fluffy-text`}
                        >
                            {message}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

NotificationBox.propTypes = {
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    color: PropTypes.string,
};

export default memo(NotificationBox);
